(function () {
    'use strict';

    angular
        .module('app')
        .controller('createVersion', createVersion);

    createVersion.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService'];

    function createVersion($location, scope, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'createVersion';

        scope.createVersionDialogShown = false;

        scope.ACN_CREATE_REVISION = 123;

        scope.xyz = { bReadyForOK: false, selectedUserItem: {} };

        scope.$on('createVersionButtonClicked', function (event, arg) {
            scope.onCreateVersionButtonClicked(arg.slx);
        });

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Handle enabling OK.
            scope.xyz.bReadyForOK = true;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {
            // Do Enables.
            scope.doEnables();
        };

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On click of the Assign button.
        scope.onCreateVersionButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_CREATE_REVISION;

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_CREATE_VERSION"]; // "Files to Assign:";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName
                });
                index++;
            });

            // Enables.
            scope.selectItem();
            // Do modal.
            scope.createVersionDialogShown = true;
            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        };

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onCreateVersionDialogOK = function () {
            scope.xyz.processing = true;
            if (scope.mode == scope.ACN_CREATE_REVISION) {
                // Execute.
                SelectionCommand_WorkflowService.CreateVersion(scope.slx).then(function (response) {
                    // Handle errors.
                    var atLeastOneError = false;
                    var selectionCommandResults = response.data;
                    var slx = selectionCommandResults.slx;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                }
                            }
                        }
                    });
                    // Close dialog and refresh grid.
                    $mdDialog.hide();
                    scope.xyz.processing = false;
                    gridDataService.updateGridRecords(slx.list);

                    editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                }, function () {
                    scope.xyz.processing = false;
                });
            }
        };

        scope.onCreateVersionDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.createVersionDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            //after the grid has been initialized
            switch (command) {
                case "createversion":
                    scope.onCreateVersionButtonClicked(records);
                    break;
            }

        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
